import { languagesSlice } from "./languagesSlice";
import * as defaultActions from "../../../../../redux/_common";

export const QPARAMS_CHANGED = "languages/QParamsChanged";
const { actions } = languagesSlice;
const moduleUrl = '/api/masterdata/languages'

export const setValidationErrors = actions.setValidationErrors;

export const getItems = (params: {}) => defaultActions.getItems(moduleUrl, actions, params);
export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);
export const getItemForEdit = (id: string) => defaultActions.getItem(`${moduleUrl}/${id}`, actions);

export const deleteItem = (id: string) => defaultActions.deleteItem(`${moduleUrl}/${id}`, actions);
export const saveItem = (item: {}, id: string | null) =>
  defaultActions.saveItem(
      moduleUrl,
      actions,
      item,
      id,
  );

export const clearItem = () => defaultActions.clearItem(actions);
export const clear = () => defaultActions.clearAll(actions);
export const clearError = () => defaultActions.clearErrors(actions);
